import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/** Merge Tailwind classes without fighting over specificity. */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}

/**
 * A unique-enough string, on every device this app actually runs on.
 *
 * `crypto.randomUUID` exists only in a **secure context** — HTTPS, or localhost. A
 * self-hosted install is very often reached at `http://192.168.1.x:8000` from a phone on
 * the same wifi, and there it is simply `undefined`: calling it throws a TypeError that
 * takes out whatever function touched it. That is not a hypothetical — it is what stopped
 * the assistant sending messages from a real phone while working perfectly in a desktop
 * browser pretending to be one.
 *
 * Nothing here needs cryptographic randomness; these are React keys and idempotency
 * keys, and time plus a random suffix is more than enough to keep them apart.
 */
export function newId(prefix = "id"): string {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID();
  }
  return `${prefix}-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
}
